import {
	clearAdvanceFilter,
	removeSelectedInput,
	setSelectedInputValue,
} from '../../../../store/action/advanceFilter';
import TableHeaderComponent from '../../components/tableHeaderComponent';
import UseSalesReturn from './hooks/useSalesReturn';
import advanceFilterIcon from '../../../../assets/image/advanceFilter.svg';
import clearAllFilter from '../../../../assets/image/clearAllFilter.svg';
import addFilter from '../../../../assets/image/AddFilter.svg';
import sortbydot from '../../../../assets/image/sort_by_group.svg';
import { ExportTable } from '../../../../store/action/export/Export';
import { useState } from 'react';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';
import AdvanceFilterSelectInput from '../../../../component/Filter/AdvanceFilterSelectInput';
import { getFiltersParams } from '../../../../helper';
import AdvanceFilter from '../../../../component/Filter/AdvanceFilter';
import Pagination from '../../../../component/pagination';
import advanceFilterOptions from '../../../../component/Filter/advanceFilterOptions';
import Table from '../../../../component/table/Table';
import PageLoader from '../../../../component/PageLoader';
import CustomAlertModel from '../../components/customAlertModel';

const SalesReturn = () => {
	const {
		salesReturn,
		bulkAction,
		suburl,
		navigate,
		setBulkAction,
		deselectRows,
		handlePrintAndDownloadPdf,
		headerDropDown,
		FilterDatalist,
		isAdvanceFilterApplied,
		dispatch,
		sortDirection,
		sortDataList,
		setHeaderDropDown,
		setIsAdvanceFilterOpen,
		handleApplyFilters,
		selectedInputs,
		handleOnFocusSelectedFilterInput,
		isLoading,
		isBulkDeleteModelOpen,
		setIsBulkDeleteModalOpen,
		deleteBulkReturnList,
		isAdvanceFilterOpen,
		salesReturnParams,
		handleDeselectAll,
		onRowClick,
		searchSelectedInputItems,
		handlePageChange,
		advanceFilterPage,
		advanceFilterTotalPages,
		handleOpenBulkReturnModal,
		handleBulkDeleteSalesReturn,
	} = UseSalesReturn();
	const [isSortBy, setIsSortBy] = useState(false);
	const sortIconMap = {
		asc: <IoIosArrowRoundUp />,
		desc: <IoIosArrowRoundDown />,
	};
	const exportTableData = (param) => {
		ExportTable(param);
	};

	const salesReturnColumn = [
		{
			field: '',
			headerClass: 'HeaderBg',
			checkboxSelection: true,
			headerCheckboxSelection: true,
			minWidth: 50,
			maxWidth: 50,
			lockPosition: true,
		},
		{
			field: 'DATE',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 200,
			maxWidth: 200,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'asc', sort_by: 'date' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								DATE
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.date]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'SALES RETURN #',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 200,
			maxWidth: 200,
			flex: 1,
			cellClass: 'left-align',
			cellRenderer: (params) => {
				const number = params.data['return_number'];
				return <p style={{ alignItems: 'left' }}>{number}</p>;
			},
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'asc', sort_by: 'return_number' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								SALES RETURN #
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.return_number]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'CUSTOMER NAME',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 200,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'asc', sort_by: 'customer_name' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								CUSTOMER NAME
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.customer_name]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},

		{
			field: 'STATUS',
			headerClass: 'HeaderBg left-align',
			suppressSizeToFit: true,
			minWidth: 200,
			maxWidth: 200,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'asc', sort_by: 'status' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								STATUS
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.status]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'RECEIVED STATUS',
			headerClass: 'HeaderBg left-align',
			suppressSizeToFit: true,
			minWidth: 200,
			maxWidth: 250,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'asc', sort_by: 'received_status' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								RECEIVED STATUS
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.received_status]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'REFUND MODE',
			headerClass: 'HeaderBg left-align',
			suppressSizeToFit: true,
			minWidth: 200,
			maxWidth: 250,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'asc', sort_by: 'payment_mode' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								REFUND MODE
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.payment_mode]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'AMOUNT',
			headerClass: 'HeaderBg right-align',
			suppressSizeToFit: true,
			minWidth: 100,
			maxWidth: 200,

			cellClass: 'right-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'asc', sort_by: 'bill_total' })}
					>
						<div>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
									justifyContent: 'end',
								}}
							>
								AMOUNT
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.bill_total]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
	];

	return (
		<div>
			<TableHeaderComponent
				bulkAction={bulkAction}
				createButton={{
					buttonName: 'Create New Sales Return',
					handler: () => navigate(`/user/${suburl}/sales-return-create`),
				}}
				closeButton={{
					showCloseButton: true,
					handler: () => {
						setBulkAction(false);
						setBulkAction([]);
						deselectRows && deselectRows();
					},
				}}
				buttons={[
					{
						id: 1,
						className: 'btn-gray',
						button: 'Delete',
						handler: () => {
							handleOpenBulkReturnModal();
						},
					},
					{
						id: 2,
						className: 'btn-gray',
						button: 'Download Pdf',
						handler: () => {
							handlePrintAndDownloadPdf('', 'download', true);
						},
					},

					{
						id: 3,
						className: 'btn-gray',
						button: 'Print',
						handler: () => {
							handlePrintAndDownloadPdf('', 'print', true);
						},
					},
				]}
				dropdownButton={
					<div className="dropdown text-end">
						<a
							className="d-block link-dark text-decoration-none dropdown-toggle"
							id="dropdownUser1"
							data-bs-toggle="dropdown"
							aria-expanded="false"
						>
							<p>{headerDropDown}</p>
						</a>
						<ul
							className="dropdown-menu font-14"
							aria-labelledby="dropdownUser1"
							style={{ minWidth: '240px' }}
						>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Drafts')}
								>
									Drafts
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Pending Approval')}
								>
									Pending Approval
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Approved')}
								>
									Approved
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Declined')}
								>
									Declined
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Receive Pending')}
								>
									Receive Pending
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Received')}
								>
									Received
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Refunded')}
								>
									Refunded
								</a>
							</li>
						</ul>
					</div>
				}
				advanceFilterButton={
					isAdvanceFilterApplied ? (
						<div>
							<button
								onClick={() => {
									dispatch(clearAdvanceFilter());
									setHeaderDropDown('All Sales Return');
								}}
								style={{
									background: 'transparent',
									color: '#FF0000',
									fontSize: '14px',
									cursor: 'pointer',
									fontWeight: '600',
									lineHeight: '24px',
								}}
							>
								<img
									src={clearAllFilter}
									alt=""
									style={{ width: '18px', height: '18px', marginRight: '8px' }}
								/>
								Clear All Filters
							</button>
						</div>
					) : (
						<button
							onClick={() => setIsAdvanceFilterOpen(true)}
							style={{
								color: '#2E63F6',
								background: 'transparent',
								fontSize: '14px',
								cursor: 'pointer',
								fontWeight: '600',
								lineHeight: '24px',
							}}
						>
							<img
								src={advanceFilterIcon}
								alt=""
								style={{ width: '18px', height: '18px', marginRight: '8px' }}
							/>
							Advanced Filters
						</button>
					)
				}
				moreButton={
					<div className="dropdown text-end ms-3">
						<a
							href="#"
							className="d-block link-dark text-decoration-none"
							id="dropdownUser1"
							data-bs-toggle="dropdown"
							aria-expanded="false"
							onClick={(e) => e.preventDefault()}
						>
							<img src={sortbydot} />
						</a>
						<ul
							className="dropdown-menu font-14"
							aria-labelledby="dropdownUser"
							style={{ minWidth: '240px' }}
						>
							<li style={{ cursor: 'pointer' }}>
								<a
									className="dropdown-item"
									style={{
										display: 'flex',
										alignItems: 'center',
										fontSize: '14px',
										fontWeight: 'bold',
										justifyContent: 'space-between',
									}}
									onClick={(e) => {
										e.stopPropagation();
										setIsSortBy(!isSortBy);
									}}
								>
									Sort By
									<span>{isSortBy ? '▼' : '▶'}</span>
								</a>
							</li>
							{isSortBy ? (
								<>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortDataList({ order_by: 'asc', sort_by: 'created_at' })}
										>
											Create Time
											<span>{sortIconMap[sortDirection?.created_at]}</span>
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortDataList({ order_by: 'asc', sort_by: 'updated_at' })}
										>
											Last Modified Time
											<span>{sortIconMap[sortDirection?.updated_at]}</span>
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortDataList({ order_by: 'asc', sort_by: 'date' })}
										>
											Date
											<span>{sortIconMap[sortDirection?.date]}</span>
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortDataList({ order_by: 'asc', sort_by: 'return_number' })}
										>
											Sales Return #<span>{sortIconMap[sortDirection?.return_number]}</span>
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortDataList({ order_by: 'asc', sort_by: 'customer_name' })}
										>
											Customer Name
											<span>{sortIconMap[sortDirection?.customer_name]}</span>
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortDataList({ order_by: 'asc', sort_by: 'bill_total' })}
										>
											Amount
											<span>{sortIconMap[sortDirection?.bill_total]}</span>
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortDataList({ order_by: 'asc', sort_by: 'payment_mode' })}
										>
											Payment Mode
											<span>{sortIconMap[sortDirection?.payment_mode]}</span>
										</a>
									</li>
								</>
							) : (
								<>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => {}}
										>
											Import Return
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => {
												exportTableData('return');
											}}
										>
											Export Return
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortDataList({ order_by: 'asc', sort_by: 'id' })}
										>
											Refresh
											<span>{sortIconMap[sortDirection?.id]}</span>
										</a>
									</li>
								</>
							)}
						</ul>
					</div>
				}
			/>
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					gap: 10,
					padding: '0px 10px',
				}}
			>
				{isAdvanceFilterApplied && (
					<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
						{selectedInputs.map((item) => (
							<AdvanceFilterSelectInput
								key={item.key}
								options={item?.data}
								placeholder={`Select ${item?.label}`}
								value={item?.value}
								disabled={false}
								onFocusCb={() => {
									if (item.value === '') {
										handleOnFocusSelectedFilterInput(item?.key);
									}
								}}
								onChange={(value) => {}}
								onSelect={(option) => {
									const updatedSelectedInput = selectedInputs.map((input) => {
										if (input.key === item?.key) {
											return {
												...input,
												value: option?.value,
											};
										}
										return input;
									});
									const params = getFiltersParams(updatedSelectedInput);
									handleApplyFilters(params);
									dispatch(setSelectedInputValue({ key: item?.key, value: option.value }));
								}}
								removeInput={() => {
									dispatch(removeSelectedInput({ key: item?.key }));
									if (item?.key === 'status') {
										setHeaderDropDown('All Sales Return');
									}
									const params = getFiltersParams(
										selectedInputs.filter((input) => input.key !== item?.key),
									);
									handleApplyFilters(params);
								}}
								className="selectInput"
							/>
						))}
						<div style={{ marginBottom: '8px', cursor: 'pointer' }}>
							<img
								src={addFilter}
								alt="Apply Filter"
								onClick={() => setIsAdvanceFilterOpen(true)}
							/>
						</div>
					</div>
				)}
			</div>
			{isLoading ? (
				<PageLoader />
			) : (
				<Table
					row={salesReturn.data}
					coloum={salesReturnColumn}
					className="productTable"
					onRowClick={onRowClick}
					bulkAction={bulkAction}
					action={setBulkAction}
					onDeselectAll={handleDeselectAll}
				/>
			)}
			<Pagination
				currentPage={isAdvanceFilterApplied ? advanceFilterPage : salesReturnParams.page}
				totalPages={isAdvanceFilterApplied ? advanceFilterTotalPages : salesReturn.totalPages}
				onChangePage={handlePageChange}
			/>
			{isAdvanceFilterOpen && (
				<AdvanceFilter
					modalLabel="Note: You can create a bill for either Yet to Receive Items or Received Items."
					isOpen={isAdvanceFilterOpen}
					advanceFilterOptions={advanceFilterOptions?.sales_return}
					onFocusSelectedFilterInput={handleOnFocusSelectedFilterInput}
					handleOnChangeSelectedFilterInput={(key, value) => searchSelectedInputItems(key, value)}
					onClose={() => {
						setIsAdvanceFilterOpen(false);
					}}
					onApply={handleApplyFilters}
				/>
			)}
			{isBulkDeleteModelOpen && (
				<CustomAlertModel
					setIsAlertModelOpen={setIsBulkDeleteModalOpen}
					isAlertModelOpen={isBulkDeleteModelOpen}
					objectSelectedList={deleteBulkReturnList}
					objectLength={deleteBulkReturnList?.length}
					customText={'Are you sare you want to delete'}
					saleTypeName={'Sales Return'}
					title={'Sales Return Delete'}
					handleBulk={handleBulkDeleteSalesReturn}
				/>
			)}
		</div>
	);
};
export default SalesReturn;
